import {

} from '../actions/constants/grideable.constants';
import { CORE_OBTENER_ENTIDADES_BASICAS_SUCCESS, CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_SUCCESS } from '../actions/constants/core.constants';

const initialState = {
  usuarios: [],
  usuariosActivosDeMiTienda: [],
  formasPago: [],
  motivosCompra: [],
  tiendas: [],
  motivos: [],
  tiposArticulo: [],
  tiposEncargo: [],
  bonificaciones: [],
  promociones: [],
  idiomas: [
    {
      key: 'es',
      label: 'ESPAÑOL',
    },
    {
      key: 'en',
      label: 'ENGLISH',
    },
    {
      key: 'pt',
      label: 'PORTUGUÊS',
    },
    {
      key: 'fr',
      label: 'FRANÇAIS',
    },
    {
      key: 'ca',
      label: 'CATALÀ',
    },
    {
      key: 'co',
      label: 'COLOMBIA',
    },
    {
      key: 'mx',
      label: 'MÉXICO',
    },
    {
      key: 'cl',
      label: 'CHILE',
    },
    {
      key: 'bq',
      label: 'BONAIRE',
    },
  ],
};

export default function coreReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CORE_OBTENER_ENTIDADES_BASICAS_SUCCESS: {
      const { usuarios, motivosCompra, formasPago, motivosDevolucion, usuariosActivosDeMiTienda, tiendas } = payload;
      return {
        ...initialState,
        usuarios,
        formasPago,
        motivosCompra,
        tiendas,
        usuariosActivosDeMiTienda,
        motivosDevolucion,
      };
    }
    case CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_SUCCESS: {
      const {  motivos, tiposArticulo, tiposEncargo, bonificaciones, subtiposArticulo, promociones } = payload;
      return {
        ...state,
        motivos,
        tiposArticulo,
        tiposEncargo,
        bonificaciones,
        subtiposArticulo,
        promociones,
      };
    }
    default:
      return state;
  }
}
